import axios from 'axios';
import moment from 'moment';
import {errorHandler} from "./libs/lib.js";

const baseurl = 'repayment';
const addKeys = ['tgl1','tgl2','partnerTransactionID','partnerLoanID'];
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                console.log('str',str);
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.total_repayment = meta.total_repayment;
                obj.principal = meta.principal;
                obj.interest_repaid = meta.interest_repaid;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `repayment_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reprocessDataUploadByFilename({filename,pjxkey}){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/reprocess-data-upload-by-filename`, {filename,pjxkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    report(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir','pjxkey'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/report${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                for (const key in meta) {
                    obj[key]=meta[key];
                }
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    reportrepaymentvstopup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/report-repayment-vs-topup${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                for (const key in meta) {
                    obj[key]=meta[key];
                }
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    reportrepaymentvsrealisasi(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/report-repayment-vs-realisasi${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                for (const key in meta) {
                    obj[key]=meta[key];
                }
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    exportreportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/export-report-xls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `repayment_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    

    detail(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {
                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                    fd.append(key, obj[key]);
                    // }
                }
                const { data } = await axios.post(`${baseurl}/import-data-xlsx`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reprocessDataUpload(obj){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/reprocess-data-upload`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    posting(obj){
        return new Promise(async (resolve, reject) => {
            try {
                let {data} = await axios.post(`${baseurl}/posting`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }

}